'use client'

import { useTranslate } from '@repo/shared/hooks'
import { Card, Typography } from '@repo/ui/components'

export const InviteCards = () => {
  const { t } = useTranslate()

  return (
    <Card
      withoutBorder
      className='flex flex-col md:flex-row items-start md:justify-between gap-md pt-md  w-full '
    >
      <Typography size='lg' weight='regular' className='whitespace-pre-line'>
        {t('clubPage_invite_description')}
      </Typography>
    </Card>
  )
}
